(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/prescript.js');

'use strict';

svs.game_results = svs.game_results || {};
svs.game_results.data = svs.game_results.data || {};
svs.game_results.app = new Marionette.Application({
  region: '#game-results',
  onStart() {
    svs.game_results.app.mainView = svs.game_results.app.getRegion();
    svs.game_results.router = new svs.game_results.Router();
    Backbone.history.start({
      pushState: true,
      root: svs.core.data.baseUrl
    });
  }
});
svs.game_results.collections = svs.game_results.collections || {};
svs.game_results.views = svs.game_results.views || {};
svs.game_results.models = svs.game_results.models || {};
svs.game_results.router = svs.game_results.router || {};
svs.game_results.constants = {
  drawStates: {
    OPEN: 2,
    CLOSED: 4,
    FINALIZED: 20
  },
  productId: {
    BOMBEN: 7
  },
  eventTypeIds: {
    EVENT_RESULT: 3,
    EVENT_HANDICAP: 6,
    RESULT: 3
  },
  challengeEventTypeIds: {
    EVENT_1X2: 1,
    EVENT_OVER_UNDER: 4,
    EVENT_H2H: 12,
    EVENT_TOTALT_ANTAL_MAL: 16,
    EVENT_BADA_LAGEN_GOR_MINST: 28,
    EVENT_12: 31
  },
  matchResultState: {
    NOT_ENTERED: 0,
    ENTERED: 1,
    FINAL: 2,
    VERIFIED: 3,
    NOT_USED: 255
  },
  sportkryssJokerBreakDate: {
    DATE: '2019-01-01'
  }
};

 })(window);